import guestAxios from "@/utils/guestAxios";

export const guestRewardsApi = {
  getProfile: () => guestAxios.get("/api/guest-portal/profile"),
  registerProfile: (payload) => guestAxios.post("/api/guest-portal/profile/register", payload),
  getLoyalty: () => guestAxios.get("/api/guest-portal/loyalty"),
  getMemberships: () => guestAxios.get("/api/guest-portal/memberships"),
  purchaseMembership: (payload) => guestAxios.post("/api/guest-portal/memberships/purchases", payload),
  cancelMembershipPurchase: (purchaseId, payload = {}) => guestAxios.post(`/api/guest-portal/memberships/purchases/${purchaseId}/cancel`, payload),
  getCoupons: () => guestAxios.get("/api/guest-portal/coupons"),
};
